import React from 'react';
import { Breakpoint, ControlLink, Text, Stack } from '@moda/om';
import { OrderItem, OrderItemStatusGroup } from '../../../hooks/useOrder';
import { useIsFineJewelryReturnPolicyCovered } from '../../../hooks/useIsFineJewelryReturnPolicyCovered';
import { AccountOrderItemDetailsReturnSection } from '../AccountOrderItemDetailsReturnSection';
import { FineJewelryReturnMessage } from '../FineJewelryReturnMessage';

import './AccountOrderItemDetailsMobile.scss';

interface Props {
  hasFineJewelry?: boolean;
  item?: OrderItem;
  orderNumber?: string;
  shouldHideCustomJewelryMessage?: boolean;
  showReturn?: boolean;
  showShippingStatus?: boolean;
  showTrack?: boolean;
}

export const AccountOrderItemDetailsMobile: React.FC<Props> = ({
  hasFineJewelry,
  item,
  orderNumber,
  shouldHideCustomJewelryMessage,
  showReturn = false,
  showShippingStatus = true,
  showTrack = false
}) => {
  const isFineJewelryReturnPolicyCovered = useIsFineJewelryReturnPolicyCovered(item);

  if (!item) return null;

  const showTrackAndReturnSection = showTrack || showReturn;

  return (
    <Breakpoint lt="sm">
      <Stack space={2} className="AccountOrderItemDetailsMobile__status-container">
        {showShippingStatus && item.attributes.shippingStatus && (
          <Stack space={1} className="AccountOrderItemDetailsMobile__status">
            <Text treatment="body2" color="cement">
              Status
            </Text>

            <Text treatment="body2" color="ink">
              {typeof item.attributes.shippingStatus === 'string'
                ? item.attributes.shippingStatus
                : 'Returned'}
            </Text>
          </Stack>
        )}

        {showTrackAndReturnSection && (
          <>
            <Stack space={3} direction="horizontal">
              {showTrack && item.attributes.shipmentTrackingUrl && (
                <section className="AccountOrderItemDetailsMobile__tracking">
                  <ControlLink
                    href={item.attributes.shipmentTrackingUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Text treatment="body2" color="ink">
                      {item?.attributes?.statusGroup === 'Returned'
                        ? 'Track Return'
                        : 'Track Shipment'}
                    </Text>
                  </ControlLink>
                </section>
              )}

              {showReturn && !hasFineJewelry ? (
                <AccountOrderItemDetailsReturnSection
                  isReturnable={item.attributes.isReturnable}
                  orderNumber={orderNumber}
                  returnPolicy={item.attributes.returnPolicy}
                  statusGroup={item.attributes.statusGroup}
                />
              ) : null}
            </Stack>
            {hasFineJewelry &&
              item.attributes.statusGroup === OrderItemStatusGroup.Shipped &&
              item.attributes.isReturnable &&
              !shouldHideCustomJewelryMessage &&
              isFineJewelryReturnPolicyCovered && <FineJewelryReturnMessage />}
          </>
        )}
      </Stack>
    </Breakpoint>
  );
};
